// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-button[data-v-0e5216f4] {\n  background: #00427e;\n  border: none;\n  border-radius: 3px;\n  padding: 14px 25px;\n  color: white;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
